module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/af-867627c537fd298125324bc38d88de90.svg";